module.exports = __webpack_public_path__ + "img/portrait-013.d8fd16db.jpg";